import React from 'react'
import { ModalFilterEntitiesControls } from './ModalFilterEntitiesControls'
import { SearchableEntity, SelectEntitiesForm } from '../selectEntitiesForm'
import {
  ModalFilterEntitiesControlContext,
  ModalFilterEntitiesEnum
} from './EntityFilterModalControlProvider'
import { Modal } from '../modal/Modal'
import './EntityFilterModal.less'
import { CustomEntitiesLoader } from '../selectEntitiesForm/FetchEntitiesFromBackendWithCustomQuery'

export type EntitiesFilterModalProps = {
  modalId: ModalFilterEntitiesEnum
  entities?: SearchableEntity[] | null
  loadEntities?: CustomEntitiesLoader
  entityType: string
  header: string
  subHeader: string
  selectedIds: number[]
  setSelectedIds: (ids: EntitiesFilterModalProps['selectedIds']) => void
}

export const EntitiesFilterModal: React.FC<EntitiesFilterModalProps> = ({
  modalId,
  entityType,
  header,
  loadEntities,
  entities,
  subHeader,
  selectedIds: originalSelectedIds,
  setSelectedIds: originalSetSelectedIds
}) => {
  const [selectedIds, setSelectedIds] =
    React.useState<number[]>(originalSelectedIds)

  const { hide, activeModal } = React.useContext(
    ModalFilterEntitiesControlContext
  )

  React.useEffect(() => {
    setSelectedIds(originalSelectedIds)
  }, [originalSelectedIds])

  const handleSubmit = React.useCallback(() => {
    hide()
    originalSetSelectedIds(selectedIds)
  }, [originalSetSelectedIds, selectedIds])
  const shown = activeModal === modalId

  return (
    <Modal
      show={shown}
      onHide={hide}
      controls={
        <ModalFilterEntitiesControls
          handleSubmit={handleSubmit}
          handleCancel={hide}
        />
      }
      header={header}
      subHeader={subHeader}
      className={`EntitiesFilterModal ${entityType}`}
      dataTest="FilterModal"
    >
      {shown && (
        <SelectEntitiesForm
          entities={entities}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          entityType={entityType}
          loadEntities={loadEntities}
        />
      )}
    </Modal>
  )
}
